"use client";

import { useTranslations } from "next-intl";
import { useParams, useRouter } from "next/navigation";
import { CheckAnimation, Text } from "@leabankab/component-library";
import { SuccessHero } from "@/components/ui";
import { useRuntimeConfig } from "@/config/runtime-config-context";
import { isTestFlow } from "@/core/flow/test-flow-id";
import { useAcknowledgeTask } from "@/hooks";
import { renderByProcess } from "@/shared/render-by-process";
import { TaskType } from "@/types";
import { ApprovedMessage } from "./components/approved-message";
import { ApprovedPageContext } from "./types";

interface Props {
	context: ApprovedPageContext;
	taskId: string;
}
const ApprovedPage = ({ context, taskId }: Props) => {
	const router = useRouter();
	const { flowId } = useParams<{ flowId: string }>();
	const t = useTranslations("pages.ApprovedPage");
	const { mock, testFlow } = useRuntimeConfig();

	// In mock mode (and for the test-flow demo) there is no FLOW backend to
	// acknowledge against; the mock store can't advance past Approved, so a
	// submit here would redirect back to this step and loop. Skip it.
	useAcknowledgeTask({
		taskId,
		taskType: TaskType.ApprovedPage,
		processType: context.process,
		enabled: !mock && !isTestFlow(flowId, testFlow),
		onSettled: () => {
			if (context.redirectUrl) {
				router.push(context.redirectUrl);
			}
		},
	});

	return (
		<>
			<SuccessHero icon={<CheckAnimation color="tertiary" />}>
				{renderByProcess<ApprovedPageContext, ApprovedPageContext>(context, {
					loan: (context) => (
						<ApprovedMessage context={context} process="loan" />
					),
					myMoney: (context) => (
						<ApprovedMessage context={context} process="myMoney" />
					),
				})}
				<Text>{t("common.text.footer")}</Text>
			</SuccessHero>
		</>
	);
};

export default ApprovedPage;
